import React from 'react';
import gql from 'graphql-tag';
import { Card, Typography, Grid, Button, Tabs, Tab, List, ListItem, ListItemAvatar, ListItemText, Avatar, CircularProgress } from '@material-ui/core';
import { teal } from '@material-ui/core/colors';
import { graphql } from 'react-apollo';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import ChangeCourse from './ChangeCourse';
import ExtraActivities from './ExtraActivities';

const DETAIL_COURSE_UNIT = gql`
    query detailCourseUnit($id: Int!){
        detailCourseUnit(id: $id) {
            id
            name
            level
            chapters {
                name
                description
                medias {
                    id
                    type
                    name
                    description
                    link
                }
            }
        }
    }
`;

export const TAB = {
    CHAPTERS: 'chapters',
    EXTRAS: 'extras'
};

const FLAG_IMAGE = "data:image/png;base64,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";

const handleClickItem = (history, chapter) => {
    localStorage.setItem("chapter", JSON.stringify(chapter));
    history.push("/detail");
}

const CourseSummary = ({ courseUnit, onOpenChangeCourse }) => (
    <Grid container spacing={2} alignItems="center" style={{ marginBottom: 16 }}>
        <Grid item xs={12} sm={6} style={{ display: 'flex', alignItems: 'center' }}>
            <img src={FLAG_IMAGE} alt="" style={{ marginRight: 16 }} />
            <div>
                <Typography variant="caption" color="textSecondary">Nível atual</Typography>
                <Typography variant="subtitle1" style={{ lineHeight: 1.3 }}>{ courseUnit.level }</Typography>
                <Typography variant="h6" style={{ lineHeight: 1.3 }}>{ courseUnit.name }</Typography>
            </div>
        </Grid>
        <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="outlined" color="primary" onClick={onOpenChangeCourse}>
                <SwapHorizIcon style={{ marginRight: 8 }} />
                Trocar livro
            </Button>
        </Grid>
    </Grid>
);

const chapterAvatarStyle = { backgroundColor: teal[50], color: teal[700] };

const ChapterList = ({ chapters, onClickChapter }) => (
    <List disablePadding>
        {
            (chapters || []).map((chapter, index) => (
                <ListItem key={`${index}-${chapter.name}`} button divider onClick={() => onClickChapter(chapter)}>
                    <ListItemAvatar>
                        <Avatar style={chapterAvatarStyle}>
                            <MenuBookIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={chapter.name} secondary={chapter.description} />
                    <ChevronRightIcon color="action" />
                </ListItem>
            ))
        }
    </List>
);

const DetailCourse = props => {

    let { loading, error, detailCourseUnit } = props.data;

    const [open, setOpen] = React.useState(false);

    if (loading)
        return <div style={{ textAlign: 'center', padding: 48 }}><CircularProgress /></div>;
    if (error) return <Typography color="error">Não foi possível carregar o livro. Tente novamente mais tarde.</Typography>;

    return (
        <>
            <CourseSummary courseUnit={detailCourseUnit} onOpenChangeCourse={() => setOpen(true)} />

            <Card>
                <Tabs
                    value={props.tab}
                    onChange={(event, tab) => props.onChangeTab(tab)}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                    style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
                >
                    <Tab value={TAB.CHAPTERS} label="Capítulos" />
                    <Tab value={TAB.EXTRAS} label="Atividades Extras" />
                </Tabs>

                {
                    props.tab === TAB.CHAPTERS
                        ? <ChapterList chapters={detailCourseUnit.chapters} onClickChapter={chapter => handleClickItem(props.history, chapter)} />
                        : <div style={{ padding: 8 }}><ExtraActivities courseUnitId={props.course_unit_id} /></div>
                }
            </Card>

            <ChangeCourse
                open={open}
                selectedCourseUnitId={props.course_unit_id}
                onClose={() => setOpen(false)}
                onClickCourse={(course) => {
                    setOpen(false);
                    props.onChangeCourseUnit(course.id);
                }} />
        </>
    )
}

export default graphql(DETAIL_COURSE_UNIT, {
    options: props => ({
        variables: {
            id: props.course_unit_id
        }
    })
  })(DetailCourse);
